import { render, staticRenderFns } from "./general-agile.vue?vue&type=template&id=3e6c1106&scoped=true&"
import script from "./general-agile.vue?vue&type=script&lang=js&"
export * from "./general-agile.vue?vue&type=script&lang=js&"
import style0 from "./general-agile.vue?vue&type=style&index=0&id=3e6c1106&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c1106",
  null
  
)

export default component.exports